import React, { Component } from "react";
import { connect } from "react-redux";
import _keys from "lodash/keys";
import _chunk from "lodash/chunk";
import _includes from "lodash/includes";
//
import {
  services,
  ages,
  heights,
  endowments,
  orientations,
  cups,
  bodyTypes,
} from "../config";
import { getVisibleBrands } from "../selectors";
import { goToBack } from "../modules/modal";
import Screen from "./ConnectedScreen";
import FormField from "../components/FormField";
import Alert from "../components/Alert";
import Checkbox from "../components/Checkbox";
import Tooltip from "../components/Tooltip";

class FiltersScreen extends Component {
  _setAgeVerified = (checked) => this.props.setFilter("ageVerified", checked);

  render() {
    const {
      isActive,
      filters,
      modelCount,
      booking,
      getModels,
      setFilter,
      toggleServiceFilter,
      cancelFilters,
    } = this.props;

    const brands = this.props.brands.map((brand) => ({
      id: brand.id,
      name:
        brand.score > 0
          ? `${brand.name} (${brand.score.toFixed(1)})`
          : brand.name,
    }));
    brands.unshift({ id: "independent", name: "Independents" });
    brands.unshift({ id: "", name: "Any agency" });

    const isTrans = booking.genderId === 2;

    // FIXME: Ugly, manually remove "A-Level" if Trans gender.
    const genderServices = isTrans
      ? services.filter((service) => service.id !== 1)
      : services;

    return (
      <Screen
        title="Filters"
        isActive={isActive}
        prevLabel="Cancel"
        nextLabel={`See ${modelCount} result${modelCount > 1 ? "s" : ""}`}
        onNext={(ev) => getModels()}
        onBack={cancelFilters}
        nextDisabled={modelCount === 0}
        onClose={false}
      >
        <div className="form">
          <FormField
            label="Age"
            value={filters.ageType || ""}
            values={ages}
            onChange={(ev) => setFilter("ageType", ev.target.value)}
          />
          <Checkbox
            className="u-mb"
            checked={filters.ageVerified}
            label="Show verified age only?"
            onChange={this._setAgeVerified}
          />
          <FormField
            label="Height"
            value={filters.heightType || ""}
            values={heights}
            onChange={(ev) => setFilter("heightType", ev.target.value)}
          />
          <FormField
            label="Body type"
            value={filters.bodyType || ""}
            values={bodyTypes}
            onChange={(ev) => setFilter("bodyType", ev.target.value)}
          />
          <FormField
            label="Cup size"
            value={filters.cup || ""}
            values={cups}
            onChange={(ev) => setFilter("cup", ev.target.value)}
          />
          {isTrans && (
            <FormField
              label="Endowment"
              value={filters.endowment || ""}
              values={endowments}
              onChange={(ev) => setFilter("endowment", ev.target.value)}
            />
          )}
          {isTrans && filters.endowment !== "post-op" && (
            <FormField
              label="Orientation"
              value={filters.orientation || ""}
              values={orientations}
              onChange={(ev) => setFilter("orientation", ev.target.value)}
            />
          )}
          <div className="form__field">
            <label>Likes</label>
            <div className="o-layout">
              {_chunk(
                genderServices,
                Math.round(genderServices.length / 2)
              ).map((col, idx) => (
                <div key={idx} className="o-layout__item u-1/2">
                  {col.map((service) => (
                    <label key={service.id} className="radio">
                      <input
                        type="checkbox"
                        value={service.id}
                        onChange={(ev) => toggleServiceFilter(ev.target.value)}
                        checked={_includes(filters.services, service.id)}
                      />
                      <Tooltip
                        name={service.name}
                        description={service.description}
                      />
                    </label>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <Alert
            info={modelCount > 0}
            danger={modelCount === 0}
            text={`**${modelCount} escorts** matching your filters`}
          />
        </div>
      </Screen>
    );
  }
}

// @connect
import { setFilterAction, toggleServiceFilterAction } from "../modules/filters";
import { getModelsAction } from "../modules/models/actions";

function mapState(state) {
  const { booking, filters, modal, models } = state;

  return {
    isActive: modal.screen === "filters",
    filters: filters.values,
    modelCount: models.onlineCount,
    brands: getVisibleBrands(state),
    booking,
  };
}

function mapDispatch(dispatch) {
  return {
    cancelFilters() {
      dispatch(goToBack());
    },
    toggleServiceFilter(serviceId) {
      dispatch(toggleServiceFilterAction(parseInt(serviceId)));
    },
    setFilter(name, value) {
      dispatch(setFilterAction(name, value));
    },
    getModels() {
      dispatch(getModelsAction());
    },
  };
}

export default connect(mapState, mapDispatch)(FiltersScreen);

// <FormField label='Gender' value={filters.gender || ''} values={genders} onChange={ev => setFilter('gender', ev.target.value)} />
// <FormField label='Cup size' value={filters.cup || ''} values={cups} onChange={ev => setFilter('cup', ev.target.value)} />
